import React from 'react'

import { Form, Col } from '_zari/core'

const UsernameFormGroup = ({ iValue }) => {
  return (
    <Form.Group>
      <Form.Label text='USUARIO' htmlFor='input-username' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.InputText id='input-username' name='input-username' defaultValue={iValue} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(UsernameFormGroup)
